<template>
    <div class="product-content">
        <div class="product-top">
            <div class="title">
                <ul>
                    <li class="title-en"></li>
                    <li class="title-ch"><span>产品与服务</span></li>
                </ul>
            </div>
        </div>
        <div class="product-center">
            <div class="product-menu">
                <ul class="product-menu-ul">
                    <li class="product-menu-li" :class="index == menu.currChecked ? 'menuChecked' : ''" v-for="(item,index) in menu.data" :key="index" @click="menuClick(item,index)">
                        <img :src="item.src" />
                        {{item.title}}
                    </li>
                </ul>
            </div>
            <div class="product-menu-info">
                <div class="product-menu-content">
                    <div class="product-menu-content-img">
                        <img  :src="menu.currItem.content.img">
                    </div>
                    <div class="product-menu-content-info">
                        <div class="product-menu-content-info-title">{{menu.currItem.title}}</div>
                        <div class="product-menu-content-info-content">
                            <p v-for="(paragraph , index) in menu.currItem.content.paragraph" :key="index">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{paragraph}}
                            </p>
                        </div>
                        <div class="product-menu-content-info-system">
                            <ul>
                                <li v-for="(system , index) in menu.currItem.content.system" :key="index">{{system.name}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            menu:{
                currChecked:null,
                currItem:null,
                data:[]
            }
        }
    },
    created(){
        let me = this;
        var newData = [];
        for(let i = 0; i < dataconfig.product.length;i++){
            let item = dataconfig.product[i];
            item.src = item.src.indexOf("-switch") > -1 ? item.src.replace("-switch","") : item.src;
            newData.push(item); 
        }
        me.menu.data = newData;
        me.menuClick(me.menu.data[0],0);
    },
    mounted(){
        
    },
    methods:{
        menuClick(item,index){
            let me = this;
            if(me.menu.currChecked == index) return;
            if(me.menu.currChecked != null){
                let oldItem = me.menu.data[me.menu.currChecked];
                oldItem.src = oldItem.src.replace("-switch","");
            }
            item.src = item.src.replace(item.id,item.id + "-switch");
            me.menu.currChecked = index;
            me.menu.currItem = item;
            const dom = document.querySelector(".product-menu-content-info-content");
            if(dom)dom.scrollTop = 0;
        }
    }
}
</script>
<style scoped lass>
    .product-content{
        width: 100%;
        height: 100%;
        background: #fafafc;

    }
    .product-top{
        width: 100%;
        height: var(--product-top-height);
        overflow: hidden;
    }
    .product-center{
        width: 100%;
        height: calc(100vh - var(--head-height) - var(--product-top-height));
    }
    .product-menu{
        width: 100%;
        height: 35%;
        display: flex;
        justify-content: center;
    }
    .product-top img{
        width:100%;
        height:100%;
    }
    .product-menu-ul{
        list-style: none;
        margin: 0;
        padding:0;
        width: 80%;
        height: 90%;
        border:1px solid #ccc;
    }
    .product-menu-li{
        width: calc(100% / 5 - 1px);
        height: calc(100% / 2);
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        float: left;
        cursor: pointer;
        font-size: 0.7vw;
        background: linear-gradient(to right,red,red) no-repeat right;
        background-size: 0 100%;
        transition:background-size 800ms , color 800ms;
        overflow: hidden;
    }
    .product-menu-li:nth-child(5){
        border-right: 0;
    }
    .product-menu-li:last-child{
        border-right: 0;
    }
    .product-menu-li:nth-of-type(n + 6){
        border-bottom: 0;
    }
    .product-menu-li-content{
        width: 80px;
        height:100px;
        font-size: 1.1rem;
        text-align: center;
        font-weight: bold;
        letter-spacing: 1px;
    }
    .product-menu-li img{
        width:2vw;
        height: 2vw;
        margin-bottom: 15px;
        transition: all 0.5s;
    }
    
    .menuChecked img{
        margin-bottom: 5px;
    }
    .menuChecked{
        /* background: red; */
        color:#fff;
        background-position-x:left !important;
        background-size: 100% 100% !important;
    }
    .product-menu-info{
        width: 100%;
        height: 65%;
    }
    .product-menu-content{
        width: 80%;
        height:100%;
        margin: 0 auto;
    }
    .product-menu-content-img{
        width: 55%;
        height: 95%;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .product-menu-content-img img{
        width: 100%;
        height: 100%;
        transition: all 0.5s;
        transform-origin: center center;
    }
    .product-menu-content-img:hover > img{
        /* width: 100%;
        height: 100%; */
        transform: scale(1.1);
    }
    .product-menu-content-info{
        width: 40%;
        height: 95%;
        float: right;
    }
    .product-menu-content-info-title{
        width: 100%;
        /* height:10%; */
        font-size: 2rem;
        font-weight: 600;
        letter-spacing: 3px;
    }
    .product-menu-content-info-content{
        line-height: 25px;
        font-size: 15px;
        letter-spacing: 2px;
        width: 100%;
        height: auto;
        /* max-height: 50%; */
        overflow-y: auto;
        color:#181818;
    }
    
    .product-menu-content-info-system{
        width: 100%;
        height: auto;
        max-height: 50%;
        font-size: 1.1rem;
        overflow-y: auto;
        font-weight: bold;
    }
    .product-menu-content-info-system ul{
        list-style: none;
        margin:0;
        padding:0;
        width: 100%;
        height: auto;
    }
    .product-menu-content-info-system ul li{
        width: auto;
        height: 40px;
        float: left;
        margin:0 20px;
        position: relative;
        display: flex;
        align-items: center;
        letter-spacing: 1px;
    }
    .product-menu-content-info-system ul li::before{
        content: "";
        width: 10px;
        height: 10px;
        background: red;
        position: absolute;
        left:-20px;
        top:16px;
        border-radius: 10px;
    }

    .title{
        width: 100%;
        height: var(--product-top-height);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
    }
    .title ul{
        list-style: none;
        padding:0;
        margin:0;
        width: auto;
        height: auto;
    }
    .title-en{
        width: 100%;
        height:auto;
        font-size: 1.5vw;
        font-weight: bold;
        letter-spacing: 3px;
        padding:2px;
    }
    .title-ch {
        width: auto;
        height:auto;
        font-size: 1.5vw;
        padding:2px;
        position: relative;
        margin: 0 auto;
        text-align: center;
    }
    .title-ch::before{
        content: "";
        width: 25px;
        height: 0;
        border:1px solid red;
        position: absolute;
        left:-40px;
        top:50%;
    }
    .title-ch::after{
        content: "";
        width: 25px;
        height: 0;
        border:1px solid red;
        position: absolute;
        right:-40px;
        top:50%;
    }
</style>


// WEBPACK FOOTER //
// src/view/page/product.vue